<toast></toast>
@if (maintenance) {
<ups-system-message></ups-system-message>
}
@if (storageAccountIsDown) {
<storage-account-down-toast></storage-account-down-toast>
}
@if (userDataIsStale) {
<user-data-stale-toast></user-data-stale-toast>
}
@if (notificationDataIsStale) {
<notification-location-data-stale-toast></notification-location-data-stale-toast>
}
@if (router.url.indexOf('/login') === -1) {
<ups-header [showHeaderMenu]="router.url.indexOf('/onproperty') === -1"></ups-header>
}
@if (!maintenance || router.url.indexOf('/login') !== -1 || router.url === '/gateway') {
<div class="main" [class.container-1]="router.url.indexOf('/onproperty') === -1" [class.on-property]="router.url.indexOf('/onproperty') !== -1">
  <router-outlet></router-outlet>
  @if ((locationListLoading$ | async) && router.url.indexOf('/login') === -1  && router.url.indexOf('/gateway') === -1 && router.url.indexOf('/no-locations') === -1) {
<div style="width:100vw">{{localize(langSection.Term, langText.Loading)}}</div>
}
</div>
}
@if (router.url.indexOf('/login') === -1 && router.url.indexOf('/onproperty') === -1) {
<ups-footer></ups-footer>
}
